(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-template"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.read-more-btn').forEach(btn => {
    const text = btn.previousElementSibling;
    if (text.scrollHeight <= text.clientHeight) {
      btn.style.display = 'none';
    }
    btn.addEventListener('click', () => {
      text.classList.toggle('expanded');
      btn.classList.toggle('active');
      const isExpanded = text.classList.contains('expanded');
      btn.setAttribute('aria-expanded', isExpanded);
      btn.querySelector('.arrow').textContent = isExpanded ? '▲' : '▼';
      btn.firstChild.textContent = isExpanded ? 'Read Less ' : 'Read more ';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
